import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, Type } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'environments/environment';
import { Observable, catchError, of, throwError } from 'rxjs';
import { TypeId, VendorItem } from '../Models/vendorItem.model';
import { MasterItem } from '../Models/masterItem.model';
import { RelatedProductsMappingItem } from '../Models/relatedProductsMappingItem.model';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MappingService {


  private URL = `${environment.apiUrl}Mapping`;
  private _http: any = null;

  constructor(private http: HttpClient) {
    this._http = http;
  }

  getVendorList(
    supplierId: number,
    taxonomy: TypeId,
    filters?: { isMapped?: boolean; isGeneralBrand?: boolean }
  ): Observable<VendorItem[]> {
    let params = new HttpParams();
    if (filters?.isMapped !== undefined) {
      params = params.set('isMapped', String(filters.isMapped));
    }
    if (filters?.isGeneralBrand !== undefined) {
      params = params.set('isGeneralBrand', String(filters.isGeneralBrand));
    }
    return this.http.get<VendorItem[]>(
      `${this.URL}/GetVendorList/${supplierId}/${taxonomy.valueOf()}`,
      { params }
    );
  }

  getVendorListByBrand(supplierId: number, taxonomy: TypeId, brandId: number): Observable<VendorItem[]> {
    return this.http
      .get<VendorItem[]>(`${this.URL}/GetVendorList/${supplierId}/${taxonomy.valueOf()}/${brandId}`)
      .pipe(
        catchError((error) => {
          console.warn('Brand-specific list endpoint unavailable, falling back to empty list.', error);
          return of([]);
        })
      );
  }

  getVendorBrandSizes(supplierId: number, brandId: number): Observable<VendorItem[]> {
    return this.http.get<VendorItem[]>(`${this.URL}/vendor-brand-sizes/${supplierId}/${brandId}`);
  }

  createBrandSpecificMapping(generalMappingId: number, brandId: number): Observable<any> {
    return this.http.post(`${this.URL}/brand-specific/${generalMappingId}/${brandId}`, {})
      .pipe(catchError(this.handleError));
  }

  createBrandSpecificSizes(payload: { brandId: number; generalMappingIds: number[] }): Observable<any> {
    return this.http.post(`${this.URL}/brand-specific-sizes`, payload)
      .pipe(catchError(this.handleError));
  }

  deleteMapping(id: number): Observable<any> {
    return this.http.delete(`${this.URL}/${id}`)
      .pipe(catchError(this.handleError));
  }

  getMasterList(taxonomy: TypeId): Observable<MasterItem[]> {
    return this.http.get<MasterItem[]>(`${this.URL}/GetMasterList/${taxonomy.valueOf()}`);
  }

  updateSystemItemId(id: number, systemItemId: number, brandId?: number, sizeTypeId?: number): Observable<any> {
    let url = `${this.URL}/UpdateSystemItemId/${id}/${systemItemId}`;

    // Add optional path parameters if provided
    if (brandId !== undefined || sizeTypeId !== undefined) {
      // If only sizeTypeId is provided, we need to pass 0 or null for brandId
      const brandIdValue = brandId !== undefined ? brandId : 0;
      url += `/${brandIdValue}`;

      if (sizeTypeId !== undefined) {
        url += `/${sizeTypeId}`;
      }
    }

    return this.http.get(url)
      .pipe(catchError(this.handleError));
  }

  async updateProducts(vendorId: number, taxonomy: TypeId): Promise<void> {
    console.log(vendorId, taxonomy);
    var taxonomyId = TypeId[taxonomy] as unknown as number;
    const response = await this.http.get<Task>(`${this.URL}/UpdateProductsAfterMapping/${vendorId}/${taxonomyId}`).toPromise();
  }

  private handleError(error: any) {
    console.error('An error occurred:', error);
    return throwError(error);
  }

  public getRelatedProducts(id: number, typeId: TypeId, sizeTypeId?: number): Promise<RelatedProductsMappingItem[]> {
    var taxonomyId = TypeId[typeId] as unknown as number;
    const url = sizeTypeId
      ? `${this.URL}/MappingProductHelperItem/${id}/${taxonomyId}/${sizeTypeId}`
      : `${this.URL}/MappingProductHelperItem/${id}/${taxonomyId}`;
    return this.http.get<RelatedProductsMappingItem[]>(url)
      .toPromise()
      .then(data => data || []); // Handle the case where data might be undefined
  }

  getOrganizations(typeId: number): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}Users/organizations/${typeId}`);
  }

}
